import { SET_ADDRESS3 } from "../actionTypes";

const initialState = "";

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ADDRESS3: {
      return action.payload;
    }
    default:
      return state;
  }
};
